namespace Matrix.Data {
    export interface DataParameterForm {
        Name: Serenity.StringEditor;
        Title: Serenity.StringEditor;
        Type: Serenity.EnumEditor;
        Required: Serenity.BooleanEditor;
        Size: Serenity.IntegerEditor;
        Scale: Serenity.IntegerEditor;
        DefaultValue: Serenity.StringEditor;
        EditorType: Serenity.LookupEditor;
    }

    export class DataParameterForm extends Serenity.PrefixedContext {
        static formKey = 'Matrix.Data.Columns.DataParameterForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DataParameterForm.init)  {
                DataParameterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;

                Q.initFormType(DataParameterForm, [
                    'Name', w0,
                    'Title', w0,
                    'Type', w1,
                    'Required', w2,
                    'Size', w3,
                    'Scale', w3,
                    'DefaultValue', w0,
                    'EditorType', w4
                ]);
            }
        }
    }
}
